import { WebStorage } from 'proxy-storage';
import getProduct from '../../core/getProduct';
import root from '../../utils/root';

const cookieStore = new WebStorage('cookieStorage');

/**
 * @public
 * Default data structure for the session.
 *
 * @type {Object}
 */
const sessionPayload = {
  Partner: '',
  TrafficSource: '',
  BiddingToolId: '',
  Label: {
    Channel: 'SEM',
    Domain: document.domain,
    Product: getProduct(document.domain),
    Src: '',
    Source: '',
    SubId: '',
    Medium: '',
    Keyword: '',
    Campaign: '',
    CampaignId: '',
    AdGroup: '',
    AdGroupId: '',
    AdId: '',
    LandingPage: root.location.href,
    MatchType: '',
    ImpactRadiusCampaignId: '',
    OptimizelyExperimentId: '',
    PublisherCampaignId: '',
    Ircid: '',
    Gclid: '',
    agent_id: '2010000',
  },
  UserContext: {
    UserId: cookieStore.getItem('healthcareUser'),
    ClientId: '',
    SessionId: '',
    UserAgent: navigator.userAgent,
    IpAddress: '',
    Browser: navigator.appName,
    BrowserVersion: navigator.appVersion,
    OperatingSystem: navigator.platform,
    OperatingSystemVersion: navigator.oscpu,
    Device: '',
    LoggedInAgentId: '',
  },
  FlowContext: {
    FlowId: '',
    ExperimentId: '',
    FlowVersion: '',
    ExperimentVariation: '',
    FlowStep: '',
  },
};

export default sessionPayload;
